import { render } from "./PreloaderPreloader.vue?vue&type=template&id=13e46bba&scoped=true"
const script = {}

import "./PreloaderPreloader.vue?vue&type=style&index=0&id=13e46bba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13e46bba"]])

export default __exports__